module.exports = __webpack_public_path__ + "img/fastfood.e08f7b05.svg";